<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <!-- Feeds-->
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mb-10 mt-10" v-if="postShow">
                <feed-item-card
                  class="test-diagno mb-5"
                  :itemData="postItem"
                  :academyPost="postItem.Key == 'akademi'"
                  :hideMoreMenu="postItem.Key == 'akademi'"
                  :postDetail="true"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";
import PostService from "../../services/PostService";

export default {
  data: () => {
    return {
      postId: "",
      postItem:{},
      postShow: false,
    };
  },
  components: {
    FeedItemCard,
  },
  methods: {
    getFeedItems() {
        setPageLoading(true)
        PostService.getPostDetail(this.postId)
        .then((res) => {
          console.log('res detail : ', res.data.Data)
          if(res.data.Data){
            this.postShow = true
            this.postItem = res.data.Data[0]
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
            setPageLoading(false)
        });
    },
  },
  computed: {

  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    console.log('postdetail :' ,this.$route.params.id)
    if (this.$route.params.id) {
      this.postId = this.$route.params.id;
      this.getFeedItems();
    }else{
       this.getFeedItems(); 
    }
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {},
};
</script>

<style>
.word-wrap {
  word-break: break-word !important;
}
</style>
